import { render, staticRenderFns } from "./car-complectation.vue?vue&type=template&id=662b4884"
import script from "./car-complectation.vue?vue&type=script&lang=js"
export * from "./car-complectation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonTypical: require('/var/www/components/button/button-typical.vue').default})
